import MaterialTable from 'material-table';
import React, { Component } from 'react';
import { API } from 'aws-amplify';
import "tabler-react/dist/Tabler.css";
import { Card, Dimmer } from "tabler-react";
import { SettingsApplicationsTwoTone } from '@material-ui/icons';

import TablaResultados from "./TablaResultados";

class CardResultado extends Component {
  constructor(props){
    super(props);
    this.state = ({
      data: [],
      alumnosTabla: []
    });
  }

  componenteDidUpdate = (prevProps, prevState) => {
  }

  componentDidMount = async () => {
    this.setState({data: this.props.data, alumnosTabla: this.props.alumnos.data.data.alumnos});
  }

  render () {
    return(
      <>
        {/* <Card title="Resultado" isClosable className="card-actividades-resultados"> */}
        <Card title="Resultado" isCollapsible className="card-actividades-resultados">
          <Card.Body>
            <Card className="tabla-actividades-resultados">
              <TablaResultados data={this.props.data} alumnos={this.props.alumnos.data.data.alumnos} curso={this.props.alumnos.curso.cursosNombres} nivel={this.props.nivel}/>
            </Card>
          </Card.Body>
        </Card>
      </>
    );
  }
}
export default CardResultado;